var React = require('react');

function TriangleDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"24/Chevron_Down"},React.createElement("path",{"id":"Vector (Stroke)","fillRule":"evenodd","clipRule":"evenodd","d":"M7.46967 9.71967C7.76256 9.42678 8.23744 9.42678 8.53033 9.71967L12 13.1893L15.4697 9.71967C15.7626 9.42678 16.2374 9.42678 16.5303 9.71967C16.8232 10.0126 16.8232 10.4874 16.5303 10.7803L12.5303 14.7803C12.2374 15.0732 11.7626 15.0732 11.4697 14.7803L7.46967 10.7803C7.17678 10.4874 7.17678 10.0126 7.46967 9.71967Z","fill":"#8EC4FF"})));
}

TriangleDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = TriangleDown;

TriangleDown.default = TriangleDown;
